export const getSubscriptionType = (subscription) => {
    const type = subscription.product.shape?.identifier;
    if (!type) {
        throw new Error(`Subscription shape identifier not found - Sku ${subscription?.sku}`);
    }
    return type;
};
